import get from 'lodash.get';

export const isItemMpCorrect = (question = {}, itemIndex, userAnswer) => {
  const answer = get(question, `answers[${itemIndex}][0]`);
  return answer && userAnswer && answer === userAnswer;
};
